import React from 'react';
import { Tabs as AntdTabs, TabsProps as AntdTabsProps, ConfigProvider } from 'antd';
import { useTheme } from '../../theme/ThemeContext';

export interface TabsProps extends AntdTabsProps {  'data-test'?: string; }

const Tabs: React.FC<TabsProps> = (props) => {
    const theme = useTheme();
    return (
        <ConfigProvider theme={theme}>
            <AntdTabs {...props} data-asper-tabs data-test={props['data-test']}/>
        </ConfigProvider>
    );
};

export default Tabs;
